export const MostImpactedTestCasesTable = [
  {
    display_name: "Expand",
    key: "open_modal",
    headerStyles: {
      width: '5%',
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      
      "font-weight": 600
    },
    _config: {
      type: "icon",
      value: "open_in_new",
      isClickable: true,
      displayInColumn: false,
    },
  },
  {
    display_name: "User Story ID",
    key: "userStoryId",
    headerStyles: {
      background: "#7593F2",
      width: "10%",
      
      color: "white",
      "font-weight": 600,
    },
  },
  {
    display_name: "User Story Description",
    key: "userStoryDescription",
    headerStyles: {
      width:"15%",
      background: "#7593F2",
      color: "white",
      
      "font-weight": 600,
    },
  },
  {
    display_name: "Test Case ID",
    key: "testcaseid",
    headerStyles: {
      width: "10%",
      background: "#7593F2",
      color: "white",
      
      "font-weight": 600,
    },
  },
  {
    display_name: "Test Case Title",
    key: "testScenario",
    headerStyles: {
      width: "20%",
      background: "#7593F2",
      color: "white",
      
      "font-weight": 600,
    }
  },
  {
    display_name: "Source Code Path",
    key: "sourcecodepath",
    headerStyles: {
       width: "20%",
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      
      "font-weight": 600
    },
  },
  {
    display_name: "Method Name",
    key: "methodname",
    headerStyles: {
       width: "20%",
      background: "#7593F2",
      padding: "4px 8px",
      
      color: "white",
      "font-weight": 600
    },
  }
];
